<div class="wrapper">

  <div class="topbar campaign clearfix">
    <div class="logo-picto">
      <a routerLink="/">
        <img class="logo-picto" src="assets/layout/images/logo-picto.png" srcset="assets/layout/images/logo-picto@2x.png 2x, assets/layout/images/logo-picto@3x.png 3x" alt="logo-picto"/>
      </a>
    </div>
    <div id="topbar-icons" class="animated">
      <span class="topbar-search">
        <h1>{{ campaign?.name }}</h1>
      </span>
      <div class="icon-right">
        <a routerLink="/support" target="_blank">
          <span class="topbar-campaign-icon fa fa-life-ring animated swing"></span>
          <span class="topbar-campaign-item-text">{{ 'campaign.support' | translate }}</span>
        </a>
        <button pButton type="button" class="SaveExit" label="{{ 'campaign.exitButton' | translate }}" routerLink="/campaign-list"></button>
      </div>
    </div>
  </div>

  <div class="maincampaign">
    <div class="card cardstep">
      <div class="ui-g ui-fluid">
        <div class="ui-g-6 campaign-card-pad actions">
          {{ 'campaign.summaryActions' | translate }}:
        </div>
        <div class="ui-g-6 campaign-card-pad text-right">
          <button pButton type="button" class="button-edit" icon="fa fa-pencil" label="{{ 'campaign.edit' | translate }}"></button>
          <button pButton type="button" class="button-deploy" icon="fa fa-thumbs-up" label="{{ 'campaign.deploy' | translate }}"></button>
        </div>
      </div>
    </div>
  </div>

  <div class="campaignstatus clearfix">
    <div class="ui-g ui-fluid">
      <div class="ui-g-6">
        <div class="status-left">
          {{ 'campaign.summaryReport' | translate }}
        </div>
      </div>
      <div class="ui-g-6">
        <div class="status-right">
          {{ 'campaign.campaignStatus' | translate }}: <span class="status-generated">Generated</span>
        </div>
      </div>
    </div>
  </div>

  <div class="campaigninfo">
    <div class="ui-g ui-fluid">
      <div class="ui-g-4">
        <div class="ui-g-4 ui-g-nopad">
          <h2>{{ 'campaign.budgetAmount' | translate }}</h2>
        </div>
        <div class="ui-g-8 ui-g-nopad text">
          <div><span class="value">{{ campaign?.budget | numberKM }}</span> {{ 'campaign.outOf' | translate }} {{ spentBudget | numberKM }} ({{ budgetPercentage }}%)</div>
          <p-progressBar [value]="budgetPercentage" [showValue]="false"></p-progressBar>
        </div>
      </div>
    </div>
  </div>

  <div class="campaigncharts">
    <div class="ui-g ui-fluid">
      <div class="ui-g-6 chart-container">
        <h2><strong>{{ totalCustomers | numberKM }}</strong> customers</h2>
        <chart id="customer-chart" [options]="charts.summary.options" (load)="chartInstance(charts.summary, $event.context)"></chart>
      </div>
      <div class="ui-g-6 chart-container">
        <button pButton type="button" class="roundedButton slim border status status-all" label="{{ 'campaign.costPerType' | translate }}" [ngClass]="{'active': chartTab == 1}" (click)="chartTab = 1"></button>
        <button pButton type="button" class="roundedButton slim border status status-all" label="{{ 'campaign.costPerChannel' | translate }}" [ngClass]="{'active': chartTab == 2}" (click)="chartTab = 2"></button>
        <chart [options]="charts.costPerType.options" (load)="chartInstance(charts.costPerType, $event.context)" [style.display]="chartTab == 1 ? 'block': 'none'"></chart>
        <div id="campaignCostPerChannelChart" [hidden]="chartTab != 2"></div>
        <chart [options]="charts.costPerChannel.options" (load)="chartInstance(charts.costPerChannel, $event.context)" [style.display]="chartTab == 2 ? 'block': 'none'"></chart>
      </div>
    </div>
  </div>

  <div class="campaigncoupons">
    <h2>{{ 'common.coupons' | translate }}</h2>
    <br /><br />
    <p-dataTable [value]="coupons">
      <p-column field="id_coupon" header="Coupon ID"></p-column>
      <p-column field="channel" header="Channel"></p-column>
      <p-column field="offer" header="Offer"></p-column>
      <p-column field="discount" header="Discount"></p-column>
      <p-column field="threshold" header="{{ 'campaign.threshold' | translate }}"></p-column>
      <p-column field="num_customer" header="Customers"></p-column>
      <p-column header="Emission Rate">
        <ng-template let-col let-coupon="rowData" pTemplate="body">
          {{ coupon.emission_rate.toFixed(2) }}%
        </ng-template>
      </p-column>
      <p-column header="Redemption Rate">
        <ng-template let-col let-coupon="rowData" pTemplate="body">
          {{ coupon.redemption_rate.toFixed(2) }}%
        </ng-template>
      </p-column>
    </p-dataTable>
  </div>

</div>




// WEBPACK FOOTER //
// ./src/app/views/campaign/summary/summary.component.html